import LoadingButton from "../LoadingButton";

interface StripeSubmitButtonProps {
  onSubmit: () => Promise<void>;
}

const StripeSubmitButton: React.FC<StripeSubmitButtonProps> = (
  {
    onSubmit
  }
) => {
  return (
    <LoadingButton
      onPress={async () => {
        await onSubmit(); // Ensure this function returns a promise
      }}
      //disabled
    >
      Submit
    </LoadingButton>
  );

};

export default StripeSubmitButton;
